const alternateLinkSelector = 'link[rel="alternate"]';

let alternateElements: NodeListOf<HTMLLinkElement>;
export const getAlternateElements = (): NodeListOf<HTMLLinkElement> => {
  return alternateElements || (alternateElements = document.querySelectorAll<HTMLLinkElement>(alternateLinkSelector));
};
